<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Empty layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
<red-empty-layout *ngIf="layout === 'empty'"></red-empty-layout>
<!-- ----------------------------------------------------------------------------------------------------- -->
<!-- Classic layout -->
<!-- ----------------------------------------------------------------------------------------------------- -->
<red-classic-layout *ngIf="layout === 'classic'"></red-classic-layout>
